
$(document).ready(function(){   
  promoPopCookie();	  
  
});


// Popup Js
  
  function promoPopCookie() {
  var promoCookie = "promo-showed";
  var promoDelay = $("#newsletter_popup").data("promo-delay");
  var promoExpiry = $("#newsletter_popup").data("promo-expiry");
  var my_setcookie = $.cookie('promo-showed');
    
  if ($("#newsletter_popup").data("promo-enabled")) {
    if (typeof my_setcookie != "undefined") {
      if (Cookies.get(promoCookie) !== "1") {
        setTimeout(function() {
          $('.popup_overlay').fadeIn();
          $('#newsletter_popup').fadeIn();  
        }, promoDelay);
      }
    }
  }

  $("#newsletter_popup .close_popup").click(function(e) {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });	
    $('.popup_overlay').fadeOut();
    $('#newsletter_popup').fadeOut();
    e.preventDefault();
  });
    
    
  $('.popup_overlay').click(function () {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });
	$(this).hide();
	$('#newsletter_popup').fadeOut();
	e.preventDefault();
  });
};

$(document).ready( function () {
    var $form = $('#mc-embedded-subscribe-form');
    if ( $form.length > 0 ) {
      $('form input[type="submit"]').bind('click', function ( event ) {
        
          if($('#mce-EMAIL').val()!=""){
            
            window.mc.ajaxOptions.success = function(response) {
              if(response.result == "error" ){
				var err_msg = response.msg;
				$('#mce-error-response').text(err_msg);
				$('#mce-error-response').show();
                $('#mc-embedded-subscribe-form').hide();
              }else{
        		$('#mc-embedded-subscribe-form').hide();
                $('.newsletter_text').hide();              
                $('.newsletter_success_text').fadeIn();
                $('.popup_wrapper .popup_modal .popup-body').css({"justify-content":"inherit"});
              }
			};      
          }
      });
    }  
    window.setInterval(function(){
      if($("#mce-error-response").text().indexOf("<a href") > 0) {
        var textToUpdate = $("#mce-error-response").text().slice(0,$("#mce-error-response").text().indexOf("<a href"));
        $("#mce-error-response").text(textToUpdate);
      }
    },500);
});